import { Brand, LockboxType } from '@bb/domain/dist/types';
import theme from 'components/theme';
import React from 'react';
import styled from 'styled-components';

export const BrandLogo: React.FC<{ brand?: Brand | LockboxType }> = ({
  brand,
}) => {
  const brandLogoMap: Record<Brand | LockboxType, string> = {
    supraLockbox: '../../../../img/SupraAlternateLogo.png',
    iBox: '../../../../img/SupraAlternateLogo.png',
    invoy: '../../../../img/SupraAlternateLogo.png',
    masterLock: '../../../../img/MasterLockLogo.svg',
    sentriLock: '../../../../img/SentriLockLogo.svg',
  };

  return brand ? (
    <LogoContainer>
      <img src={brandLogoMap[brand]} width={34} style={{ padding: '3px' }} />
    </LogoContainer>
  ) : (
    <EmptyLogoContainer />
  );
};

export const LogoContainer = styled.div`
  display: flex;
  background-color: white;
  align-items: center;
  border: 1px solid ${theme.neutral4};
  border-radius: 25px;
  height: 36px;
  width: 36px;
`;

const EmptyLogoContainer = styled(LogoContainer)`
  border: none;
`;
